import { toast } from "react-toastify";
import { getUserDetailsService } from "../../../Services/UserService";
import { fetchUserStart, fetchUserSuccess, fetchUserFailure } from "./reducer";

export const fetchUserDetails = (id) => async (dispatch) => {
  try {
    dispatch(fetchUserStart());
    const response = await getUserDetailsService(id);
    if (response) {
      dispatch(fetchUserSuccess(response.data || response));
    } else {
      toast.error("Something went wrong ");
      dispatch(fetchUserFailure("No User found"));
    }
  } catch (error) {
    dispatch(fetchUserFailure(error));
  }
};
